// src/components/ContactForm.js
import React, { useState } from 'react';
import { supabase } from '../utils/supabaseClient';
import '../styles/ContactForm.css';

function ContactForm() {
  const storedExpert = JSON.parse(localStorage.getItem('selectedExpert'));
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    expert: storedExpert ? storedExpert.name : ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { error } = await supabase.from('contacts').insert([
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
        },
      ]);

      if (error) {
        console.error("Supabase error:", error);
        alert("Submission failed. Try again.");
        return;
      }

      setSubmitted(true);
      setFormData({ name: '', email: '', message: '', expert: '' });
      localStorage.removeItem('selectedExpert');
    } catch (err) {
      console.error("Unexpected error:", err);
      alert("Something went wrong. Try again.");
    }
  };

  return (
    <section className="contact-form" id="contact">
      <h2>Contact Us</h2>
      {submitted ? (
        <p style={{ textAlign: 'center', fontSize: '18px', color: 'green' }}>
          Thank you! Your message has been sent.
        </p>
      ) : (
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
            required
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            required
          />
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Your Phone number"
            required
          />
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit">Send Message</button>
        </form>
      )}
    </section>
  );
}

export default ContactForm;
